import { Link } from 'react-router'
import { type Route } from './+types/genealogy-research.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Genealogy Research | EBHS' },
	{
		name: 'description',
		content:
			'Genealogy research at the East Bloomfield Historical Society.',
	},
]

export default function GenealogyResearchPage() {
	return (
		<div className="px-4 pb-8 pt-4">
			<div className="mx-auto max-w-6xl sm:px-6 lg:px-8">
				<header className="py-5">
					<h1 className="text-3xl font-bold leading-tight text-gray-900">
						Genealogy Research
					</h1>
				</header>

				<div className="grid grid-cols-1 md:grid-cols-3">
					<img
						src="/images/ebhs/genealogy/genealogy-large.png"
						alt="A Family Portrait"
						className="mx-auto w-64"
					/>
					<p className="py-4 text-lg md:col-span-2">
						In the Genealogy Department at the East Bloomfield Historical
						Society, we currently have 92,090 records in our genealogy database,
						and over 1,000 Family Surname Folders on families that currently live
						or have lived here in the past. Some information we have include
						articles on birth, marriage, and death and many articles written about
						the family members. We also have 124 Genealogy Books on local families
						given to us by family members. These books give the genealogy written
						and/or researched/compiled by a member of the family.
					</p>
				</div>
				<p className="py-4 text-lg">
					Have you had DNA done through Ancestry, My Heritage, 23 and Me, Family
					Tree DNA, etc.? It is great to know your origins but wouldn&apos;t it be
					even better if you also had all the particulars about your ancestors
					including information on birth, marriage and death records, where they
					lived, family stories, newspaper articles about your family, pictures,
					etc.? We have a wonderful collection of East Bloomfield History, Ontario
					County History, local and some nearby Church and Cemetery Records,
					Scrapbooks, Newspaper Clippings and much more.
				</p>
				<p className="py-4 text-lg">
					We receive requests from people from all over the U.S. asking for any
					information we have in our files on their family. Many people are
					researching their family tree, journalists are writing books on people
					who lived here, etc.
				</p>

				<header className="py-4">
					<h3 className="text-3xl font-bold leading-tight text-gray-900">
						Beginning Your Genealogical Research
					</h3>
				</header>
				<p className="py-4 text-lg">
					You can begin your family inquiry by visiting our{' '}
					<Link to="/records/genealogy" className="text-blue-700 underline">
						index of records
					</Link>
					. There you will enter the family surname you are researching to see if
					it is contained in our archives. When there is a match, all individuals
					with that surname will be displayed along with each given name and middle
					initial. The location where each name can be found will also be listed.
					We will research our files and gather all the information we find by
					checking our database. We make copies of all the information we find and
					send it to you. We do charge a nominal fee for each copy, postage and a
					fee for the number of hours you authorize us to research all our files.
				</p>
				<img
					src="/images/ebhs/genealogy/wedding-photo-2.png"
					alt="Wedding"
					className="mx-auto w-64"
				/>
				<header className="py-4">
					<h3 className="text-3xl font-bold leading-tight text-gray-900">
						Scheduling a Visit
					</h3>
				</header>
				<p className="py-4 text-lg">
					If you are interested in visiting the Historical Society to continue your
					research, you can schedule an appointment with our genealogist. The
					genealogy staff is available most Thursdays from 9:00 a.m. - 2:00 p.m.
					or by scheduled appointment.
				</p>
				<p className="py-4 text-lg">
					Completing the{' '}
					<a
						href="https://ebhs1838.s3.amazonaws.com/research_request_form.pdf"
						className="text-blue-700 underline"
						target="_blank"
						rel="noreferrer"
					>
						Research Request Form
					</a>{' '}
					before the appointment will assist the genealogy staff in better aiding
					you in your request for family information.
				</p>
				<header className="py-4">
					<h3 className="text-3xl font-bold leading-tight text-gray-900">
						Research Requests
					</h3>
				</header>
				<div className="grid grid-cols-1 md:grid-cols-3">
					<p className="py-4 text-lg md:col-span-2">
						If you are not able to schedule a visit or prefer to have the
						genealogy staff conduct the research, complete the{' '}
						<a
							href="https://ebhs1838.s3.amazonaws.com/research_request_form.pdf"
							className="text-blue-700 underline"
							target="_blank"
							rel="noreferrer"
						>
							Research Request Form
						</a>{' '}
						and send to the East Bloomfield Historical Society along with a $20
						payment. When research is completed, a bill will be submitted to you
						and upon receipt of payment (personal or certified bank check), our
						research will be mailed to you.
					</p>
					<img
						src="/images/ebhs/genealogy/wedding-photo-3.png"
						alt="Wedding"
						className="mx-auto w-64"
					/>
				</div>
				<header className="py-4">
					<h3 className="text-3xl font-bold leading-tight text-gray-900">
						Research Fees
					</h3>
				</header>
				<div className="py-4 text-lg">
					<h4 className="font-semibold">Members:</h4>
					<p className="px-10 py-4">
						Members in good standing receive one half hour of genealogy volunteer
						research free annually. Members can do their own in-office research
						without charge. Making copies with our copier are $.25 per black page,
						$.50 per color page. Postage and handling additional, as required.
					</p>

					<img
						src="/images/ebhs/genealogy/wedding-photo-4.png"
						alt="Wedding"
						className="mx-auto w-64"
					/>

					<h4 className="font-semibold">Non-members:</h4>
					<p className="px-10 py-4">
						$10 per visit plus the cost of any copies.
					</p>
					<p className="px-10 py-4">
						Research done by our volunteer staff is $20/hour (plus copy fees).
					</p>
					<div className="px-10 py-4">
						Copy Fees:
						<ul className="pl-10">
							<li>$.25 per page - Black/White copy.</li>
							<li>$.50 per page - Color copy.</li>
							<li>$.15 per page using your camera or scanner.</li>
							<li>$.50 each for digitally scanned computer material.</li>
							<li>Postage and handling additional, as required.</li>
						</ul>
					</div>
					<h4 className="font-semibold">Professional Organization Request:</h4>
					<p className="px-10 py-4">Fee subject to negotiation.</p>
				</div>
			</div>
		</div>
	)
}
